import {
  LOAN_APPLICATION_USER_GOTO_START,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
  LOAN_APPLICATION_USER_GOTO_FAILURE,
  LOAN_APPLICATION_USER_GOBACK_START,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
  LOAN_APPLICATION_USER_GOBACK_FAILURE,
  LOAN_APPLICATION_USER_VERIFY_START,
  LOAN_APPLICATION_USER_VERIFY_SUCCESS,
  LOAN_APPLICATION_USER_VERIFY_FAILURE,
} from './types';

//
// GO BACK ACTIONS
//
export const loanApplicationUserGobackStart = (payload) => ({
  type: LOAN_APPLICATION_USER_GOBACK_START,
  payload: payload
})

export const loanApplicationUserGobackSuccess = (payload) => ({
  type: LOAN_APPLICATION_USER_GOBACK_SUCCESS,
  payload: payload
})

export const loanApplicationUserGobackFailed = (payload) => ({
  type: LOAN_APPLICATION_USER_GOBACK_FAILURE,
  payload: payload
})

//
// GO TO ACTIONS
//
export const loanApplicationUserGotoStart = (payload) => ({
  type: LOAN_APPLICATION_USER_GOTO_START,
  payload: payload
})

export const loanApplicationUserGotoSuccess = (payload) => ({
  type: LOAN_APPLICATION_USER_GOTO_SUCCESS,
  payload: payload
})

export const loanApplicationUserGotoFailed = (payload) => ({
  type: LOAN_APPLICATION_USER_GOTO_FAILURE,
  payload: payload
})

// VERIFICATION
//
export const loanApplicationUserVerifyStart = (payload) => ({
  type: LOAN_APPLICATION_USER_VERIFY_START,
  payload: payload
})

export const loanApplicationUserVerifySuccess = (payload) => ({
  type: LOAN_APPLICATION_USER_VERIFY_SUCCESS,
  payload: payload
})

export const loanApplicationUserVerifyFailure = (payload) => ({
  type: LOAN_APPLICATION_USER_VERIFY_FAILURE,
  payload: payload
})
